export default {
    navList: [{
        title: '首页',
        link: 0
    }, {
        title: '解决方案',
        link: 700
    }, {
        title: '产品中心',
        link: 1500
    }, {
        title: '服务支持',
        link: 2200
    }, {
        title: '公司简介',
        link: 2900
    }, {
        title: '合作案例',
        link: 3700
    }, {
        title: '业务联系',
        link: 5500
    }],
    solutionList: [{
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/solution2.png',
        title: '智能穿戴硬件方案',
        content: '提供人体各部位穿戴相关产品的消费电子方案'
    }, {
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/solution3.png',
        title: '智能生活硬件方案',
        content: '提供智能化健康家居生活产品的消费电子方案'
    }, {
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/solution4.png',
        title: '智能终端硬件方案',
        content: '提供共享设备、无人零售、检测终端等物联方案'
    }, {
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/solution5.png',
        title: '物联网云平台软件',
        content: '集群式高并发的物联设备云平台建设'
    }, {
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/solution6.png',
        title: '智慧门店SaaS软件',
        content: '针对服务业门店的智慧零售scrm系统'
    }, {
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/solution7.png',
        title: '新零售电商SaaS软件',
        content: '针对品牌电商的线上线下联动的零售系统'
    }],
    productObj: {
        nav: ['全部', '智能穿戴', '智能生活'],
        arr: [{
            productList: [{
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product22.png',
                title: '智能芯内衣(青春款)',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product23.png',
                title: '智能芯内衣(经典款)',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product24.png',
                title: '智能体脂称',
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product25.png',
                title: '矫正按摩器',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product26.png',
                title: '智能眼罩',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product27.png',
                title: '智能枕头',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product28.png',
                title: 'AI测肤仪',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product30.png',
                title: '智能艾灸器',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }],
        }, {
            productList: [{
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product22.png',
                title: '智能芯内衣(青春款)',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product23.png',
                title: '智能芯内衣(经典款)',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product26.png',
                title: '智能眼罩',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product27.png',
                title: '智能枕头',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }],
        }, {
            productList: [{
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product24.png',
                title: '智能体脂称',
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product25.png',
                title: '矫正按摩器',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product28.png',
                title: 'AI测肤仪',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }, {
                img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/product30.png',
                title: '智能艾灸器',
                content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
            }]
        }, ]

    },

    serviceList: [{
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/service8.png',
        title: '产品批发',
        content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
    }, {
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/service9.png',
        title: 'OEM生产',
        content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
    }, {
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/service10.png',
        title: '方案定制',
    }, {
        img: 'https://static-wxcommunity.penguinvip.com/yunzhihui/service11.png',
        title: '培训咨询',
        content: '容内容内容容内容内容容内容内容容内容内容容内容内容容内容内容'
    }],
    partnerList: [{
            selectedimg: 'https://static-wxcommunity.penguinvip.com/yunzhihui/partner13.png',
            unselectedimg: 'https://static-wxcommunity.penguinvip.com/yunzhihui/partner14.png',
            banner: 'https://static-wxcommunity.penguinvip.com/yunzhihui/partner19.png',
            title: '南方日报',
            desc: '',
            detail: ''
        },
        {
            selectedimg: 'https://static-wxcommunity.penguinvip.com/yunzhihui/partner17.png',
            unselectedimg: 'https://static-wxcommunity.penguinvip.com/yunzhihui/partner18.png',
            banner: 'https://static-wxcommunity.penguinvip.com/yunzhihui/partner21.png',
            title: '惠州西湖',
            desc: '',
            detail: ''
        },
        {
            selectedimg: 'https://static-wxcommunity.penguinvip.com/yunzhihui/partner15.png',
            unselectedimg: 'https://static-wxcommunity.penguinvip.com/yunzhihui/partner16.png',
            banner: 'https://static-wxcommunity.penguinvip.com/yunzhihui/partner20.png',
            title: '乐象有品',
            desc: '',
            detail: ''
        },

    ]

}


// WEBPACK FOOTER //
// ./src/view/mock.js